import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconLockGradient = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    viewBox="0 0 25 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-lock-gradient_svg__a)"
      d="M20 9c1.64 0 3 1.36 3 3v9.047C23 22.687 21.64 24 20 24H5c-1.688 0-3-1.313-3-3v-9c0-1.64 1.313-3 3-3h1.5V6c0-3.281 2.672-6 6-6 2.578 0 4.875 1.688 5.672 4.172.187.61-.094 1.219-.703 1.406a1.12 1.12 0 0 1-1.407-.703C15.547 3.328 14.095 2.25 12.5 2.25A3.731 3.731 0 0 0 8.75 6v3H20Zm.75 12v-9c0-.375-.375-.75-.75-.75H5c-.422 0-.75.375-.75.75v9c0 .422.328.75.75.75h15c.375 0 .75-.328.75-.75Z"
    />
    <defs>
      <linearGradient
        id="icon-lock-gradient_svg__a"
        x1={23}
        x2={-0.788}
        y1={0}
        y2={20.814}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.18} stopColor="#EEE" />
        <stop offset={0.73} stopColor="#A0A0A0" />
        <stop offset={1} stopColor="#979797" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconLockGradient;
